import { useContext } from 'react';

import { ToastContext } from './index';

const useToast = () => useContext(ToastContext);

export default useToast;
